import { type UploadFileData } from "@src/appV2/lib/Media/types";

export enum BadgeVerificationStep {
  INTRO = "intro",
  CONFIRM = "confirm",
  GRADING = "grading",
  GRADING_TIMED_OUT = "grading-timed-out",
  NO_BADGE = "no-badge",
  SKIP_CONFIRM = "skip-confirm",
  SKIP_RESULT = "skip-result",
}

export interface BadgeVerificationPhoto extends UploadFileData {
  previewUrl: string;
}
